enum GroupNotification {
  UnassignedToFacilitator = 'UNASSIGNED_TO_FACILITATOR',
  UnassignedToProject = 'UNASSIGNED_TO_PROJECT',
  UnassignedGroupStatus = 'UNASSIGNED_GROUP_STATUS',
}

export default GroupNotification;
